import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IonicModule } from '@ionic/angular';

export interface ButtonRadioOption {
    value: any;
    label: string;
    icon?: string;
    selectedIconColor?: string;
}

@Component({
    selector: 'app-button-radio-group',
    imports: [IonicModule],
    template: `
        <div class="button-radio-group">
            @for (option of options; track option.value) {
                <ion-button
                    (click)="select(option.value)"
                    [color]="isSelected(option.value) ? selectedColor : unselectedColor"
                    [fill]="isSelected(option.value) ? 'solid' : 'outline'"
                    [disabled]="disabled"
                    class="radio-button"
                >
                    @if (option.icon) {
                        <ion-icon
                            [name]="option.icon"
                            [color]="isSelected(option.value) ? option.selectedIconColor : 'medium'"
                            slot="start"
                        ></ion-icon>
                    }
                    {{ option.label }}
                </ion-button>
            }
        </div>
    `,
    styles: [`
        .button-radio-group {
            display: flex;
            gap: 8px;
        }
        .radio-button {
            flex: 1;
            height: 40px;
            max-width: 250px;
        }
    `]
})
export class ButtonRadioGroupComponent {
    @Input() options: ButtonRadioOption[] = [];
    @Input() value: any = null;
    @Input() disabled = false;
    @Input() selectedColor = 'eventslight';
    @Input() unselectedColor = 'medium';
    @Output() valueChange = new EventEmitter<any>();

    isSelected(optionValue: any): boolean {
        return this.value === optionValue;
    }

    select(optionValue: any): void {
        if (this.disabled) return;
        this.value = optionValue;
        this.valueChange.emit(optionValue);
    }
}
